import { PERMISSION_KEYS, UI_LABELS, ROLES } from "../constants";

export const ROLE_PRESETS = {
  [ROLES.UNSURE]: {
    id: ROLES.UNSURE,
    name: UI_LABELS.UNSURE,
    description: "Minimal default permissions - user will customize manually",
    permissions: [
      PERMISSION_KEYS.TODOS.CREATE_DIARY,
      PERMISSION_KEYS.TODOS.EDIT_OWN_DIARY,
    ],
  },

  [ROLES.SUPERVISOR]: {
    id: ROLES.SUPERVISOR,
    name: UI_LABELS.SUPERVISOR,
    description: "Full relationship, workkard, activity, notes management",
    autoCheckTemplates: true,
    permissions: [
      // Manage Relationships
      PERMISSION_KEYS.STATIC_PARENTS.MANAGE_RELATIONSHIPS,
      PERMISSION_KEYS.RELATIONSHIPS.SEND_B2B_REQUEST,
      PERMISSION_KEYS.RELATIONSHIPS.ACCEPT_REJECT_B2B_REQUEST,
      PERMISSION_KEYS.RELATIONSHIPS.MANAGE_CONTRACTS,
      PERMISSION_KEYS.RELATIONSHIPS.DEASSOCIATE_B2B_RELATIONSHIP,
      PERMISSION_KEYS.RELATIONSHIPS.ADD_REMOVE_EXCLUDE_LIST,
      PERMISSION_KEYS.RELATIONSHIPS.VIEW_B2B_WORKLOAD,

      // Manage Workkards (parent unchecked, children checked)
      PERMISSION_KEYS.WORKKARDS.CREATE_WORKKARD,
      PERMISSION_KEYS.WORKKARDS.CHANGE_WORKKARD_SPONSOR,
      PERMISSION_KEYS.WORKKARDS.EDIT_WORKKARD,
      PERMISSION_KEYS.WORKKARDS.ARCHIVE_WORKKARD,
      PERMISSION_KEYS.WORKKARDS.RECEIVE_UNASSIGNED_WORKKARDS,
      PERMISSION_KEYS.WORKKARDS.CLOSE_WORKKARD,
      PERMISSION_KEYS.WORKKARDS.REOPEN_WORKKARD,

      // Manage Activity
      PERMISSION_KEYS.STATIC_PARENTS.MANAGE_ACTIVITY,
      PERMISSION_KEYS.ACTIVITY.CREATE_ACTIVITY,
      PERMISSION_KEYS.ACTIVITY.REOPEN_ACTIVITY,
      PERMISSION_KEYS.ACTIVITY.CLOSE_ACTIVITY,
      PERMISSION_KEYS.ACTIVITY.ACCEPT_REJECT_ACTIVITY,
      PERMISSION_KEYS.ACTIVITY.ARCHIVE_ACTIVITY,
      PERMISSION_KEYS.ACTIVITY.ACCEPT_REJECT_BID,
      PERMISSION_KEYS.ACTIVITY.REASSIGN_ACTIVITY,
      PERMISSION_KEYS.ACTIVITY.RECEIVE_UNASSIGNED_ACTIVITIES,
      PERMISSION_KEYS.ACTIVITY.CHANGE_ACTIVITY_OWNER,
      PERMISSION_KEYS.ACTIVITY.MARK_ACTIVITY_IN_PROGRESS,
      PERMISSION_KEYS.ACTIVITY.COMPLETE_ACTIVITY,
      PERMISSION_KEYS.ACTIVITY.CLOSE_ACTIVITY_MIDTERM,
      PERMISSION_KEYS.ACTIVITY.ASSIGN_B2B,
      PERMISSION_KEYS.ACTIVITY.EDIT_ACTIVITY,

      // Manage Notes
      PERMISSION_KEYS.STATIC_PARENTS.MANAGE_NOTES,
      PERMISSION_KEYS.NOTES.MANAGE_WORKKARD_NOTES,
      PERMISSION_KEYS.NOTES.MANAGE_WORKKARD_NOTES_PUBLIC,
      PERMISSION_KEYS.NOTES.MANAGE_WORKKARD_NOTES_PRIVATE,
      PERMISSION_KEYS.NOTES.MANAGE_ACTIVITY_NOTES,
      PERMISSION_KEYS.NOTES.MANAGE_ACTIVITY_NOTES_PUBLIC,
      PERMISSION_KEYS.NOTES.MANAGE_ACTIVITY_NOTES_PRIVATE,
      PERMISSION_KEYS.NOTES.DELETE_UPDATE_NOTES_TIMEFRAME,
      PERMISSION_KEYS.NOTES.CLONE_NOTES,

      // Manage Parties
      PERMISSION_KEYS.STATIC_PARENTS.MANAGE_PARTIES,
      PERMISSION_KEYS.PARTIES.CREATE_PARTY,
      PERMISSION_KEYS.PARTIES.DELETE_PARTY,
    ],
  },

  [ROLES.ADMIN]: {
    id: ROLES.ADMIN,
    name: UI_LABELS.ADMIN,
    description: "User management, settings, and system administration",
    permissions: [
      PERMISSION_KEYS.USERS.EDIT_USER,
      PERMISSION_KEYS.USERS.BLOCK_USER,
      PERMISSION_KEYS.USERS.ADD_USER,
      PERMISSION_KEYS.USERS.RESET_PASSWORD,


      PERMISSION_KEYS.SINGLE.MANAGE_SETTINGS,
      PERMISSION_KEYS.SINGLE.MANAGE_COMPANY_PROFILE,
      PERMISSION_KEYS.SINGLE.INVITE_USER_TO_COMMUNITY,
      PERMISSION_KEYS.SINGLE.MANAGE_RULES,


      PERMISSION_KEYS.STATIC_PARENTS.MANAGE_PARTIES,
      PERMISSION_KEYS.PARTIES.CREATE_PARTY,
      PERMISSION_KEYS.PARTIES.DELETE_PARTY,


      PERMISSION_KEYS.TODOS.CREATE_DIARY,
      PERMISSION_KEYS.TODOS.EDIT_OWN_DIARY,
    ],
  },

  [ROLES.EMPLOYEE]: {
    id: ROLES.EMPLOYEE,
    name: UI_LABELS.EMPLOYEE,
    description: "Basic workkard and activity management",
    autoCheckTemplates: true,
    permissions: [
      PERMISSION_KEYS.WORKKARDS.CHANGE_WORKKARD_SPONSOR,


      PERMISSION_KEYS.ACTIVITY.CREATE_ACTIVITY,
      PERMISSION_KEYS.ACTIVITY.REOPEN_ACTIVITY,
      PERMISSION_KEYS.ACTIVITY.CLOSE_ACTIVITY,
      PERMISSION_KEYS.ACTIVITY.ACCEPT_REJECT_ACTIVITY,
      PERMISSION_KEYS.ACTIVITY.REASSIGN_ACTIVITY,
      PERMISSION_KEYS.ACTIVITY.CHANGE_ACTIVITY_OWNER,
      PERMISSION_KEYS.ACTIVITY.ASSIGN_B2B,


      PERMISSION_KEYS.STATIC_PARENTS.MANAGE_NOTES,
      PERMISSION_KEYS.NOTES.MANAGE_WORKKARD_NOTES,
      PERMISSION_KEYS.NOTES.MANAGE_WORKKARD_NOTES_PUBLIC,
      PERMISSION_KEYS.NOTES.MANAGE_WORKKARD_NOTES_PRIVATE,
      PERMISSION_KEYS.NOTES.MANAGE_ACTIVITY_NOTES,
      PERMISSION_KEYS.NOTES.MANAGE_ACTIVITY_NOTES_PUBLIC,
      PERMISSION_KEYS.NOTES.MANAGE_ACTIVITY_NOTES_PRIVATE,
      PERMISSION_KEYS.NOTES.DELETE_UPDATE_NOTES_TIMEFRAME,
      PERMISSION_KEYS.NOTES.CLONE_NOTES,


      PERMISSION_KEYS.TODOS.CREATE_DIARY,
      PERMISSION_KEYS.TODOS.EDIT_OWN_DIARY,
    ],
  },
};

export const resolveRolePresets = (rolePresets, availableKeySet) => {
  const resolved = {};
  Object.entries(rolePresets).forEach(([roleId, preset]) => {
    resolved[roleId] = {
      ...preset,
      permissions: (preset.permissions || []).filter((key) =>
        availableKeySet.has(key),
      ),
    };
  });
  return resolved;
};

export const ROLE_INFO_TEXT = {
  [ROLES.SUPERVISOR]:
    "Supervisors have full control over relationships, workkards, activities, and notes. They can manage all aspects of the claims process.",
  [ROLES.ADMIN]:
    "Administrators have system-level permissions including user management, settings, and company configuration.",
  [ROLES.EMPLOYEE]:
    "Employees have basic permissions for creating and managing workkards and activities within their scope.",
  [ROLES.UNSURE]:
    'Select "Unsure" to manually configure permissions based on specific needs.',
};
